import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { useContext } from 'react'
import { Context } from '@/context'
import { fragments } from '@/hooks/fragments'
import {
  ELanguageCode,
  Mutation,
  MutationCreateAuctionArgs,
} from '@/schemaTypes'
import { auctionFragments } from './auctionFragments'

const CREATE_AUCTION = gql`
  mutation createAuction(
    $args: AuctionCreateArgs!
    $shouldNotifyCustomers: Boolean!
    $languageCode: ELanguageCode!
  ) {
    createAuction(args: $args, shouldNotifyCustomers: $shouldNotifyCustomers) {
      ...AuctionDetailsFragment
    }
  }
  ${fragments.customDealFormQuestion}
  ${fragments.formAnswers}
  ${auctionFragments.auctionDetails}
  ${fragments.address}
`

type TData = { createAuction: Mutation['createAuction'] }
type TVariables = { languageCode?: ELanguageCode } & MutationCreateAuctionArgs

export function useCreateAuction(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  const { language } = useContext(Context)

  const [createAuction] = useMutation<TData, TVariables>(CREATE_AUCTION, {
    ...opts,
    variables: { ...(opts.variables as TVariables), languageCode: language },
  })
  return createAuction
}
